import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "@/App";
import "@/index.css";

const rootElement = document.getElementById("root");
const hasSsrMarkup = rootElement.firstElementChild !== null;
const initialData = window.__OMNIVAAS_ROUTE_DATA__ || {};

if (hasSsrMarkup) {
  hydrateRoot(rootElement, <App initialData={initialData} />);
} else {
  createRoot(rootElement).render(<App initialData={initialData} />);
}
